import { FormikProvider, useFormik } from 'formik';
import { useTranslation } from 'react-i18next';

import { useLocalize } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';
import { GraphQLErrorMessage, Input, Modal, Paragraph, Popover } from '@treams/treams-ui';

export default function CycleMomentSendReminderModal(props: {
	instance: graphql.MomentInstance;
	onDismiss: () => void;
}) {
	const { t } = useTranslation();
	const { localize } = useLocalize();

	const [commit, { error }] = graphql.useSendMomentReminderMutation();

	const formik = useFormik({
		initialValues: {
			text: '',
		},
		onSubmit: async (values) => {
			await commit({
				variables: {
					input: {
						id: props.instance.id,
						text: values.text,
					},
				},
			});

			props.onDismiss();
		},
	});

	return (
		<Popover center visible>
			<Modal>
				<Modal.Header
					title={localize(props.instance.momentTemplate.title).text}
					onClose={() => props.onDismiss()}
				/>
				<Modal.Contents>
					<Paragraph mb={2}>{t('inbox.cycle.moments.sendReminder.text')}</Paragraph>
					<FormikProvider value={formik}>
						<Paragraph mb={3}>{t('inbox.cycle.moments.sendReminder.description.label')}</Paragraph>
						<Input.Formik name="text" />
					</FormikProvider>
					<GraphQLErrorMessage error={error?.graphQLErrors[0]} />
				</Modal.Contents>
				<Modal.FormFooter
					onCancel={() => props.onDismiss()}
					saveTitle={t('inbox.cycle.moments.sendReminder.skipButton')}
					onSave={() => formik.submitForm()}
				/>
			</Modal>
		</Popover>
	);
}
